import React from "react";
import "./footer.css";


function Footer(){
  return(
    <div id="Footer">
          <div className="footer-container">

                <div className="footer-copyright">
                      <h1 className="footer-copyright-h1"><span className="footer-copyright-h1-span">© 2024</span> MADE BY AKSHAT</h1>
                </div>


                <div className="footer-links">
                      <div className="footer-link">
                            <a className="footer-a" href="https://www.linkedin.com/in/akshat-chouhan-46165b1ab/" target="_blank"><i class="fa fa-linkedin"></i></a>
                      </div>
                      <div className="footer-link">
                            <a className="footer-a" href="https://twitter.com/Aks_sc" target="_blank"><i class="fa fa-twitter"></i></a>
                      </div>
                      <div className="footer-link">
                            <a className="footer-a" href="https://github.com/AkshatSC" target="_blank"><i class="fa fa-github"></i></a>
                      </div>

                </div>

          </div>








    </div>
  );
}

export default Footer;
